/* ------------------------------------------------------------------------ */
/*		File: spinner.tsx                                                   */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

/* eslint-disable react/jsx-pascal-case */

import React, { CSSProperties, useEffect, useState } from "react";

import "./spinner.css";
import { PulseLoader, RotateLoader } from "react-spinners";
import { ISpinner } from "./generic";


const override: CSSProperties = {
    display: "block",
    margin: "0 auto",
};


/* ------------------------------------------------------------------------ */

const Spinner: React.FC<ISpinner> = (props) => {
    const [color, setColor] = useState<string>("#54A5DC"); 
    const colors = ["#54A5DC", "#FEE42D", "#EE7B6C"]; 
    let interval: any;
    useEffect(() => {
        if (props.type !== "symy"){
            const interval = setInterval(() => {
                setColor(prevColor => {
                    const currentIndex = colors.indexOf(prevColor);
                    const nextIndex = (currentIndex + 1) % colors.length;
                    return colors[nextIndex];
                });
            }, 1000); 
        }

        return () => clearInterval(interval); 
    }, [props.type]);


    const getClassName = () => {
        switch (props.type) {
            case "initial": return "card_spinner";
            case "symy": return "card_spinner_symy";
            default: return "card_spinner_container";
        }
    };

    return (
        <div className={getClassName()}>
            {props.type === "symy" ? (
                <PulseLoader
                    color={color}
                    loading={props.isLoading}
                    cssOverride={override}
                    size={5}
                    data-label='Loading'
                    aria-label='Loading'
                />
            ) : (
                <RotateLoader
                    color={color}
                    loading={props.isLoading}
                    cssOverride={override}
                    size={25}
                    data-label='Loading'
                    aria-label='Loading'
                />
            )}
        </div>
    )
};

export default Spinner;
